import { getData } from "@/lib/prismic/data";
import { SliceZone } from "@prismicio/react";
import { notFound } from "next/navigation";
import { use } from "react";
import { components } from "@/slices";
import OurServices from "@/components/organisms/our-services";

const Aboutpage = ({ resolution }: TemplateProps) => {
  const document = use(getData(resolution));

  if (!document) return notFound();

  return (
    <>
      <SliceZone slices={document.data.slices} components={components} />
      <OurServices locale={resolution.locale} />
    </>
  );
};

export default Aboutpage;
